export const residentials = {
  methods: {
    socialAdd(ev) {
      this.newSocial.type = this.temp.type;
      if (this.newSocial.type == 3 || this.newSocial.type == 4) {
        this.$set(this, "newRoadDots", [
          { x: this.getScaledPointerPosition(ev).x, y: this.getScaledPointerPosition(ev).y },
        ]);
        this.$emit("update:action", "newRoad");
      } else {
        this.newSocial.lat = this.getScaledPointerPosition(ev).x;
        this.newSocial.lng = this.getScaledPointerPosition(ev).y;
        this.$emit("update:action", "default");
        this.$bvModal.show("socialAdd");
      }
    },
    socialRoadAdd() {
      this.$emit("update:action", "default");
      this.$nextTick(() => {
        this.newRoadDots.splice(-1, 1);
      });
      this.newSocial.dots = this.newRoadDots;

      this.$bvModal.show("socialAdd");
    },
  },
};
